import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'status'
})

export class StatusPipe implements PipeTransform {
    /**controllo lo stato e ritorno un icona
     * @param  {any} value
     * @returns status
     */
    transform(value: any): string {
        let status: string = "";
        if (value != null) {
            switch (value) {
                case "private":
                    status = '<i class="fas fa-lock"></i>';
                    break;

                case "public":
                    status = '<i class="fas fa-globe"></i>';
                    break;

                case "archived":
                    status = '<i class="fas fa-trash"></i>';
                    break;

                case "delete":
                    status = '<i class="fas fa-times"></i>';
                    break;

                case "wait":
                    status = '<i class="fas fa-pause"></i>';
                    break;
            }
        }
        return status;
    }
}